import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { NAV_ITEMS } from '../data';

import logo from '../assets/MY LOGO.png';
// import logo from '../assets/LOGO.png';
const logoSrc = logo;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => setIsOpen(false);

  const routeMap = {
    'Home': '/',
    'About': '/about',
    'Services': '/services',
    'Portfolio': '/portfolio',
    'Shop': '/shop',
    'Blog': '/blog',
    'Contact': '/contact',
  };

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-black/80 backdrop-blur-xl border-b border-white/5' : 'bg-transparent'
      }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* ─── Logo with Image ─── */}
          <button onClick={() => { navigate('/'); setIsOpen(false); }} className="flex items-center gap-3 group">
            <img
              src={logoSrc}
              alt="Isnap Media"
              className="h-9 w-auto object-contain transition-all duration-300 group-hover:scale-105"
            />
            {/* <span className="font-serif text-xl font-bold text-white">Isnap Media</span> */}
          </button>

          <div className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item}
                to={routeMap[item]}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${isActive
                    ? 'text-white bg-yellow-500/20 border border-yellow-500/30'
                    : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`
                }
                onClick={handleNavClick}
              >
                {item}
              </NavLink>
            ))}
            <NavLink
              to="/contact"
              className="ml-3 px-5 py-2 rounded-full bg-gradient-to-r from-yellow-500 to-yellow-600 text-white text-sm font-medium hover:shadow-lg hover:shadow-yellow-500/30 transition"
            >
              Hire Me
            </NavLink>
          </div>

          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-gray-300 hover:text-white p-2">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-black/90 backdrop-blur-xl border-b border-white/5">
          <div className="px-4 py-4 space-y-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item}
                to={routeMap[item]}
                className={({ isActive }) =>
                  `block w-full text-left px-4 py-3 rounded-lg text-sm transition-all ${isActive
                    ? 'text-white bg-yellow-500/20 border border-yellow-500/30'
                    : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`
                }
                onClick={handleNavClick}
              >
                {item}
              </NavLink>
            ))}
            <NavLink
              to="/contact"
              className="block w-full mt-2 px-4 py-3 rounded-lg bg-gradient-to-r from-yellow-500 to-yellow-600 text-white text-sm font-medium text-center"
              onClick={handleNavClick}
            >
              Hire Me
            </NavLink>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;